import { useEffect, useState } from 'react';

// iPhone / iPad mini / iPad are designed together from day one (task book §19).
// These two breakpoints are the single source; src/ui/theme.css must use the same pixel
// values in its @media rules — tests/app/responsive.test.ts pins that cross-file agreement.
export const VIEWPORT_TIERS = Object.freeze({
  phoneMaxWidth: 743,
  tabletMiniMaxWidth: 1023
});

// Foldables (2026-10-25: iPhone Duo, Pixel Fold, Galaxy Z Fold) are CSS only and leave the tiers above alone.
// A wide screen is at least minWidth wide AND minHeight tall — a phone held upright is narrower, a phone turned
// sideways is shorter, so neither layout changes; from twoColumnMinWidth the area workspace and lists go two
// across. theme.css uses the same pixels (tests/app/responsive.test.ts).
export const WIDE_LAYOUT = Object.freeze({
  minWidth: 600,
  minHeight: 500,
  twoColumnMinWidth: 840
});

export type ViewportTier = 'phone' | 'tabletMini' | 'tablet';

export function tierForWidth(width: number): ViewportTier {
  if (width <= VIEWPORT_TIERS.phoneMaxWidth) return 'phone';
  if (width <= VIEWPORT_TIERS.tabletMiniMaxWidth) return 'tabletMini';
  return 'tablet';
}

export function useViewportTier(): ViewportTier {
  const [tier, setTier] = useState<ViewportTier>(() => tierForWidth(window.innerWidth));
  useEffect(() => {
    const onResize = () => setTier(tierForWidth(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return tier;
}
